import { technologies, technologiesDescription } from '../../data/content';
import './Technologies.css';

function Technologies() {
  return (
    <section id="tecnologias" className="section technologies">
      <div className="container">
        <div className="section-header">
          <h2>Tecnologias</h2>
        </div>

        <div className="tech-badges">
          {technologies.map((tech) => (
            <span key={tech} className="tech-badge">{tech}</span>
          ))}
        </div>

        <p className="tech-description">{technologiesDescription}</p>
      </div>
    </section>
  );
}

export default Technologies;
